import script from "./infoDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./infoDialog.vue?vue&type=script&lang=ts&setup=true"

import "./infoDialog.vue?vue&type=style&index=0&id=1a9c6203&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a9c6203"]])

export default __exports__